import ConfigField from '../ConfigField';
import { NODE_CONFIG_FIELDS } from '../../../constants';

export default function WalletLoadConfig({ data, onChange }) {
  const fields = NODE_CONFIG_FIELDS.wallet_load;

  return (
    <div className="space-y-4">
      {fields.map((field) => (
        <div key={field.key}>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">{field.label}</label>
          <ConfigField field={field} value={data[field.key]} onChange={(v) => onChange(field.key, v)} allData={data} onChangeField={onChange} />
        </div>
      ))}
      {data.inputType && (
        <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-xs text-amber-700">
            {data.inputType === 'Mnemonic'
              ? 'Enter your 12 or 24-word recovery phrase separated by spaces.'
              : 'Enter your wallet private key. It will be stored locally in this workflow only.'}
          </p>
        </div>
      )}
    </div>
  );
}
